
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/content-migrations/jst/subviews/CourseFindSelect';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <select id=\"courseSelect\" class=\"span3\">\n      <option value=\"default\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.course_find_select")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.course_find_select.select_default", "Select a course", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.course_find_select.select_default", "Select a course", options)))
    + "</option>\n       ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.terms), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </select>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.course_find_select")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.course_find_select.or", "or", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.course_find_select.or", "or", options)))
    + "\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n       <optgroup label=\"";
  if (helper = helpers.term) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.term); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n           ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.courses), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n         </optgroup>\n       ";
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n             <option value=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.label) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</option>\n           ";
  return buffer;
  }

  buffer += "<label class=\"control-label\" for=\"courseSearchField\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.course_find_select")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.course_find_select.search_label", "Search for a course", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.course_find_select.search_label", "Search for a course", options)))
    + "</strong></label>\n\n<div class=\"controls\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.show_select), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <input id=\"courseSearchField\" type=\"text\" placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.course_find_select")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.course_find_select.course_name", "Course name", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.course_find_select.course_name", "Course name", options)))
    + "\" name=\"courseSearchField\" class='span3'/>\n\n  <i id=\"courseSelectWarning\" class=\"course_select_warning icon-warning\" data-tooltip='{\"tooltipClass\":\"popover popover-padded\", \"position\":\"right\"}'\n       title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("content_migrations.subviews.course_find_select")
  },data:data},helper ? helper.call(depth0, "importing_course_content_into_the_same_course_will_b09c69e", "Importing course content into the same course will duplicate content the first time and overwrite duplicates if repeated.", options) : helperMissing.call(depth0, "t", "importing_course_content_into_the_same_course_will_b09c69e", "Importing course content into the same course will duplicate content the first time and overwrite duplicates if repeated.", options)))
    + "\">\n  </i>\n  <br>\n  <label class=\"checkbox\" for=\"include_completed_courses\">\n    "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'checked': ((depth0 && depth0.include_concluded))
  },data:data},helper ? helper.call(depth0, "include_completed_courses", options) : helperMissing.call(depth0, "checkbox", "include_completed_courses", options)))
    + "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.course_find_select")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.course_find_select.include_completed_courses", "Include completed courses", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.course_find_select.include_completed_courses", "Include completed courses", options)))
    + "\n  </label>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  